import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../core/i18n'
import InputRadio from '../atoms/InputRadio'
import Select from '../atoms/Select'

export interface ISpecialRankOption {
  value: string
  label: string
}

interface IProps {
  name: string
  specialRankOptions: ISpecialRankOption[]
  agentRankId: number | null
  onChange(agentRankId: number | null): void
}

// ガイドの種類(通常ガイド/特殊)ラジオ + 特殊選択時のみ特殊ランクのセレクトを表示する表示専用コンポーネント。
// agentRankId が null なら通常ガイド。特殊ラジオ選択時は先頭ランクを自動選択するため
// 「特殊かつランク未選択」の状態は発生しない。選択可能な特殊ランクがなければ特殊ラジオ自体を出さない。
export const GuideKindSelector: React.FC<IProps> = ({
  name,
  specialRankOptions,
  agentRankId,
  onChange,
}) => {
  const isSpecial = agentRankId != null
  const radioOptions = [
    { id: `${name}_normal`, label: I18n.t('guide_kind.normal', { locale: 'ja' }), value: 'normal' },
    ...(specialRankOptions.length > 0
      ? [
          {
            id: `${name}_special`,
            label: I18n.t('guide_kind.special', { locale: 'ja' }),
            value: 'special',
          },
        ]
      : []),
  ]

  return (
    <Wrapper>
      <InputRadio
        name={name}
        directionRow={true}
        options={radioOptions}
        defaultValue={isSpecial ? 'special' : 'normal'}
        onChangeHandler={e =>
          onChange(e.target.value === 'special' ? Number(specialRankOptions[0].value) : null)
        }
      />
      {isSpecial && (
        <Select
          name={`${name}_agent_rank_id`}
          options={specialRankOptions}
          value={String(agentRankId)}
          onChangeHandler={e => onChange(Number(e.target.value))}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 16px;
`

export default GuideKindSelector
